import * as React from "react";
const SvgFiBrandsDrupal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M21.185 14.814v.003a9.185 9.185 0 0 1-18.37-.003c0-4.302 2.872-7.171 5.405-9.702C9.909 3.424 11.52 1.815 12 0c.479 1.815 2.091 3.424 3.779 5.112 2.534 2.531 5.405 5.4 5.406 9.702m-3.14 1.739c.32-.697.862-2.809-.708-5.252S12 5.284 12 5.284L10.303 6.98c-.345.345-1.089 1.005-.223 1.94.985 1.064 6.246 6.563 6.849 7.455.275.406.314.597.686.583.208-.008.363-.256.43-.405m-2.886 1.964a3.1 3.1 0 0 0-.792-2.093c-.593-.66-2.367-2.649-2.367-2.649s-1.802 1.96-2.372 2.656a3.3 3.3 0 0 0-.787 2.086 3.159 3.159 0 1 0 6.318 0m-4.673-5.884a.217.217 0 0 0-.002-.308L7.933 9.538c-3.855 3.815-1.777 7.397-1.214 7.416.059.002.156.01.222-.178.322-.899 2.917-3.502 3.526-4.126z"
    />
  </svg>
);
export default SvgFiBrandsDrupal;
